import * as React from 'react'

import { makeStyles, Button, Typography, Box, withStyles, AppBar, Toolbar, } from '@material-ui/core'

import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { TheInitialInterviewSuggestionType, GroupCoachingLevelName, GroupCoachingLevelPrice } from '../constants';
import moment from 'moment'
const Accordion = withStyles({
    root: {
        border: 'none',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        margin: '4px 0',
        borderRadius: '4px',
        backgroundColor: '#EDF4FF',
        color: '#287CFF',
        minHeight: 50,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: '16px 0',
    },
}))(MuiAccordionDetails);

const StyledTypography = withStyles({
    root: {
        lineHeight: 1.8,
        letterSpacing: .5
    },
    body2: {
        color: '#1f1f1f',
    }
})(Typography)

const StyledButton = withStyles({
    root: {
        backgroundColor: '#287CFF'
    }
})(Button)

type InitialInterviewPreviewProps = {
    suggestions: any,
    coachName: string,
    otherSuggestion: string,
    isVip: boolean,
    coaches: Coach[]
}

const InitialInterviewPreview = ({ suggestions, coachName, isVip, coaches, otherSuggestion }: InitialInterviewPreviewProps) => {

    const computedDisCountFee = (type: string, isDiscount6?: number, numberOfTimes: string = '0', coachId?: string, groupCoachingLevel?: string) => {
        const [coach] = coaches.filter(coach => coachId === `${coach.user_id}`)
        if (type === TheInitialInterviewSuggestionType.one_on_one_coaching) {
            if (coach) {
                if (isDiscount6) {
                    return coach.price_discount_6 * +numberOfTimes * (isVip ? 0.9 : 1)
                } else if (+numberOfTimes >= 3 && +numberOfTimes < 6) {
                    return coach.price_discount_level1 * +numberOfTimes * (isVip ? 0.9 : 1)
                } else if (+numberOfTimes >= 6) {
                    return coach.price_discount_level2 * +numberOfTimes * (isVip ? 0.9 : 1)
                } else {
                    return coach.price * +numberOfTimes * (isVip ? 0.9 : 1)
                }
            } else {
                return 0;
            }
        } else if (type === TheInitialInterviewSuggestionType.group_coaching) {
            return groupCoachingLevel ? GroupCoachingLevelPrice[groupCoachingLevel] * (isVip ? 0.9 : 1) : 0
        }
        return 0;
    }

    const FeeView = (suggestion: TheInitialInterviewSuggestion) => {
        const disCountFee = computedDisCountFee(suggestion.type, suggestion.isDiscount6, suggestion.numberOfTimes, suggestion.coachId, suggestion.groupCoachingLevel)
        const originFee = suggestion.fee ? +suggestion.fee : 0
        const hasDiscount = disCountFee ? disCountFee !== originFee : false;

        return <React.Fragment>
            <Typography component={hasDiscount ? "s" : 'p'} variant="body2">价格: {originFee}元</Typography>
            {hasDiscount && <Typography variant="body2" style={{ fontWeight: 500 }} >{isVip ? '会员价' : '折扣价'}: {disCountFee}元 (节省 {originFee - disCountFee}元)</Typography>}
        </React.Fragment>
    }

    return <Box p={3}>
        <Box mt={2.5}>
            <Toolbar style={{ backgroundColor: '#fff' }}>
                <Typography style={{ width: '100%' }} variant="h6" align="center">首次约谈服务建议</Typography>
            </Toolbar>
        </Box>
        <Box overflow="auto" height="628px">
            <Box padding={2} >
                <Box>
                    <StyledTypography variant="body2">
                        非常感谢您选择根基家庭支持中心的首次约谈服务！根据此次约谈了解的信息，为您提供如下的建议：
                </StyledTypography>
                </Box>
                <Box mt={2}>

                    {suggestions[TheInitialInterviewSuggestionType.free_course] &&
                        <Accordion expanded={true}>
                            <AccordionSummary>
                                <Box>
                                    1. 线上免费课程
                            </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box display="flex" flexDirection="column">
                                    {suggestions[TheInitialInterviewSuggestionType.free_course].courses && suggestions[TheInitialInterviewSuggestionType.free_course].courses.map((course: Course) =>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="#f9f9f9" borderRadius={4} p={1} boxSizing="border-box" mb={1.5} width="100%">
                                            <Typography variant="body2">
                                                {course.name}
                                            </Typography>
                                        </Box>)
                                    }
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    }
                    {suggestions[TheInitialInterviewSuggestionType.vip] &&
                        <Accordion expanded={true}>
                            <AccordionSummary>
                                <Box>
                                    2. 推荐线上会员
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box display="flex" justifyContent="flex-end" width="100%">
                                    <StyledButton variant="contained" color="primary">查看会员介绍</StyledButton>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    }
                    {suggestions[TheInitialInterviewSuggestionType.one_on_one_coaching] &&
                        <Accordion expanded={true}>
                            <AccordionSummary>
                                <Box>
                                    3. 1对1教练
                            </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box width="100%">
                                    <Box>
                                        <Typography variant="body2" >
                                            次数: {suggestions[TheInitialInterviewSuggestionType.one_on_one_coaching].numberOfTimes}
                                        </Typography>
                                        <Typography variant="body2" >
                                            教练: {suggestions[TheInitialInterviewSuggestionType.one_on_one_coaching].coachName}
                                        </Typography>
                                    </Box>
                                    <Box mt={4} display="flex" justifyContent="space-between">
                                        <Box display="flex" flexDirection="column" justifyContent="center">
                                            {FeeView(suggestions[TheInitialInterviewSuggestionType.one_on_one_coaching])}
                                        </Box>
                                        <Box flexShrink={0}><StyledButton variant="contained" >立即支付</StyledButton></Box>
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    }

                    {suggestions[TheInitialInterviewSuggestionType.group_coaching] &&
                        <Accordion expanded={true}>
                            <AccordionSummary>
                                <Box>
                                    4.团体教练
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box width="100%">
                                    <Box>
                                        <Typography variant="body2" >
                                            {GroupCoachingLevelName[suggestions[TheInitialInterviewSuggestionType.group_coaching].groupCoachingLevel]}
                                        </Typography>

                                    </Box>
                                    <Box mt={4} display="flex" justifyContent="space-between">
                                        <Box display="flex" flexDirection="column" justifyContent="center">
                                            {FeeView(suggestions[TheInitialInterviewSuggestionType.group_coaching])}
                                        </Box>
                                        <Box flexShrink={0}><StyledButton variant="contained" >立即支付</StyledButton></Box>
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    }
                    {suggestions[TheInitialInterviewSuggestionType.follow_wxmp] &&
                        <Accordion expanded={true}>
                            <AccordionSummary>
                                <Box>
                                    5. 关注公众号
                            </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Typography variant="body2">
                                        微信搜索“根基成长教育”
                                    </Typography>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    }

                    {suggestions[TheInitialInterviewSuggestionType.recommends_hospital] &&
                        <Accordion expanded={true}>
                            <AccordionSummary>
                                <Box>
                                    6. 建议到医院寻求诊断和治疗
                            </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Typography variant="body2">
                                        {suggestions[TheInitialInterviewSuggestionType.recommends_hospital].content}
                                    </Typography>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    }
                </Box>
                <Box mt={2}>
                    <Typography variant="body2" style={{ whiteSpace: 'pre-wrap' }}>{otherSuggestion}</Typography>
                </Box>
                <Box mt={2}>
                    <StyledTypography variant="body2">
                        希望这些建议能够对您有帮助。
                </StyledTypography>
                    <StyledTypography variant="body2">
                        如果您需要进一步的帮助，请随时联系我们。因为您的难处，我们在乎！
                </StyledTypography>
                </Box>
                <Box mt={5}>
                    <Typography align="right" variant="body2">首次约谈的根基家庭教练：<span style={{ display: 'inline-block', width: '84px' }}>{coachName}</span></Typography>
                    <Typography align="right" variant="body2" style={{ marginTop: '4px' }}>日期：<span style={{ display: 'inline-block', width: '84px' }}>{moment().format('YYYY-MM-DD')}</span></Typography>
                </Box>
            </Box>
        </Box>
    </Box>
}

export default InitialInterviewPreview